import React, { Fragment, useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

// Material-UI Core
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'

// Custom Component
import { Alert } from '../Alert/Alert'
import DividerText from '../Divider/DividerText'

// Custom Style
import signInStyle from '../../styles/jss/components/signIn/signInStyle'

// Fetch Data
import { obtainToken, makeSignIn } from '../../dataSource/signIn'

const store = require('store')
const useStyles = makeStyles((theme) => signInStyle(theme))

const SignIn = () => {
	const passInputRef = useRef()
	const history = useHistory()
	const classes = useStyles()
	const dispatch = useDispatch()

	const [loginValue, setLoginValue] = useState({
		loginId: '',
		password: '',
	})

	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: '',
		title: '',
		content: '',
	})

	// Build Alert
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content,
		})
		setAlertOpen(true)
	}

	// Handle Input
	const handleInputChange = (name) => (event) => {
		setLoginValue({ ...loginValue, [name]: event.target.value })
	}

	const resetLoginId = () => {
		setLoginValue({ ...loginValue, ['password']: '' })
		passInputRef.current.focus()
	}

	const oidcInternalSignInAction = () => {
		let oidc_login_url = process.env.REACT_APP_OIDC_INT_LOGIN_URL
		const url = new URL(oidc_login_url)
		if (url.search.length > 0) {
			oidc_login_url += `&redirect_uri=${process.env.REACT_APP_OIDC_REDIRECT_URI}`
		} else {
			oidc_login_url += `?redirect_uri=${process.env.REACT_APP_OIDC_REDIRECT_URI}`
		}

		window.location.href = oidc_login_url
	}

	const oidcExternalSignInAction = () => {
		let oidc_login_url = process.env.REACT_APP_OIDC_EXT_LOGIN_URL
		const url = new URL(oidc_login_url)
		if (url.search.length > 0) {
			oidc_login_url += `&redirect_uri=${process.env.REACT_APP_OIDC_REDIRECT_URI}`
		} else {
			oidc_login_url += `?redirect_uri=${process.env.REACT_APP_OIDC_REDIRECT_URI}`
		}

		window.location.href = oidc_login_url
	}

	const saveLoginInfo = async (token, loginInfo) => {
		// console.log(loginInfo.data[0].company.category[0])
		store.set('site', loginInfo.data[0].site.site_seq)
		store.set('site_code', loginInfo.data[0].site.code)
		store.set('user_seq', loginInfo.data[0].user_seq)
		store.set('site_user_seq', loginInfo.data[0].site_user_seq)
		store.set('locale', 10001)
		store.set('username', loginInfo.data[0].username)
		store.set('fullname', loginInfo.data[0].fullname)
		store.set(
			'user_category_code',
			loginInfo.data[0].company.category[0].category_code || ''
		)
		store.set('current_module_seq', null)
		store.set('access_token', token.data.access_token)
		store.set('refresh_token', token.data.refresh_token)
		store.set('loggedIn', true)
	}

	const handleSignIn = (event) => {
		event.preventDefault()

		obtainToken(loginValue.loginId, loginValue.password).then((token) => {
			if (token === null) {
				buildAlert({
					// Alert Type: success, info, warning, error
					type: 'error',
					title: 'Login Failure Alert',
					content: 'Login Failure, Please try again',
				})

				resetLoginId()
				return
			}

			try {
				if (token.status === 200) {
					makeSignIn('Bearer ' + token.data.access_token).then((res) => {
						dispatch({
							type: 'FETCH_AUTH',
							data: res.data,
						})

						// console.log("Login Information")
						// console.log(res)

						saveLoginInfo(token, res).then(() => {
							history.push('/dashboard')
							// window.location.reload()
						})
					})
				}
			} catch (error) {
				throw new Error(error)
			}
		})
	}

	return (
		// console.log("User Site (Redux) | Variable: userSiteRedux (SingIn.js)"),
		// console.log(userSiteRedux),

		// console.log("User Module (Redux) | Variable: userModuleRedux (SingIn.js)"),
		// console.log(userModuleRedux),

		// console.log("---------------------------------------------------------------------------------"),

		<Fragment>
			<Alert
				open={alertOpen}
				alertType={alertData.type}
				alertTitle={alertData.title}
				alertContent={alertData.content}
				handleClose={() => setAlertOpen(false)}
			/>

			{/* <div className={classes.background} style={{backgroundImage: `url(${bgImage})`}}> */}
			<div className={classes.background}>
				{/* <Container component="main" maxWidth="xs">
						<Paper className={classes.noticePaper}> 
							<div className={classes.noticefont}>請注意:</div>
							<div className={classes.noticefont}>由2021年4月7日起，CMS網址由原來的</div>
							<div className={classes.noticefont}>https://www.sanfieldcms.com.hk</div>
							<div className={classes.noticefont}>更改為</div>
							<div className={classes.noticefont}>https://cms.sanfield.com.hk</div>
						</Paper>
					</Container> */}

				<div className={classes.root}>
					<Container component="main" maxWidth="xs">
						<Paper className={classes.paper}>
							<Box className={classes.logo}>
								<img
									src={require('../../img/sanfield-logo.png')}
									alt="Sanfield (management Ltd"
									width="300"
									height="50"
								/>
							</Box>

							{/* <form className={classes.form} noValidate onSubmit={handleSignIn}>
							<TextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								autoFocus
								id="loginId"
								name="loginId"
								label="Login ID"
								value={loginValue.loginId}
								onChange={handleInputChange("loginId")}
							/>

							<TextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								id="password"
								name="password"
								label="Password"
								type="password"
								value={loginValue.password}
								inputRef={passInputRef}
								onChange={handleInputChange("password")}
							/>

							<Button
								type="submit"
								fullWidth
								variant="contained"
								color="primary"
								className={classes.submit}
							>
								Sign In
							</Button>
						</form> */}

							<Button
								type="submit"
								fullWidth
								variant="contained"
								color="primary"
								className={classes.oidcSignInBtn}
								onClick={oidcInternalSignInAction}
								// disabled
							>
								Sanfield Portal Login
							</Button>

							<DividerText>OR</DividerText>
							{/* <DividerText className={classes.divider}>For Sanfield Internal Staff Only</DividerText> */}

							<Button
								type="submit"
								fullWidth
								variant="contained"
								color="secondary"
								className={classes.oidcSignInBtn}
								onClick={oidcExternalSignInAction}
								// disabled
							>
								External Party Login
							</Button>
						</Paper>
					</Container>
				</div>
			</div>
		</Fragment>
	)
}

export default SignIn
